// extracted by mini-css-extract-plugin
export var banner = "_p5-0";
export var settingRow = "_p5-2";
export var titleIcon = "_p5-1";